import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { downloadContratoDocumentoAuxiliar } from '../../store/modules/ContratosActions';
import {
  FILE_TYPE_GIF,
  FILE_TYPE_JPEG,
  FILE_TYPE_JPG,
  FILE_TYPE_PDF,
  FILE_TYPE_PNG,
  FILE_TYPE_WORD_DOC,
  FILE_TYPE_WORD_DOCX,
} from '../../utils/FileUtils';
import CustomDownloadButton from '../CustomDownloadButton/CustomDownloadButton';
import FileIcon from '../Icons/FileIcon';
import FileImageIcon from '../Icons/FileImageIcon';
import FilePdfIcon from '../Icons/FilePdfIcon';
import FileWordIcon from '../Icons/FileWordIcon';
import styles from './DocumentoAuxiliarItem.scss';
import CustomButton from '../CustomButton/CustomButton';
const rootClassName = styles.rootClassName;

class DocumentoAuxiliarItem extends Component {
  getIcon = () => {
    switch (this.props.extencaoArquivo.toLowerCase()) {
      case FILE_TYPE_GIF:
      case FILE_TYPE_JPEG:
      case FILE_TYPE_JPG:
      case FILE_TYPE_PNG:
        return <FileImageIcon />;
      case FILE_TYPE_PDF:
        return <FilePdfIcon />;
      case FILE_TYPE_WORD_DOC:
      case FILE_TYPE_WORD_DOCX:
        return <FileWordIcon />;
      default:
        return <FileIcon />;
    }
  };

  render() {
    return (
      <div className={rootClassName}>
        <div className={rootClassName + '-icon-container'}>
          {this.getIcon()}
          <div className={rootClassName + '-extension'}>
            {this.props.extencaoArquivo.toUpperCase()}
          </div>
        </div>
        <div className={rootClassName + '-name-container'}>
          {this.props.nome}
        </div>
        <div className={rootClassName + '-button-container'}>
          <div className={rootClassName + '-date'}>
            Atualizado em {this.props.dataAlteracao}
          </div>
          <CustomDownloadButton
            id={this.props.elementId + '-' + this.props.index}
            buttonComponent={CustomButton}
            buttonComponentProps={{
              theme: 'pufvYellow',
            }}
            fileName={this.props.nome + '.' + this.props.extencaoArquivo}
            downloadAction={this.props.downloadContratoDocumentoAuxiliar}
            downloadActionData={this.props.id}
          />
        </div>
      </div>
    );
  }
}

DocumentoAuxiliarItem.propTypes = {
  index: PropTypes.number,
  elementId: PropTypes.string,
  id: PropTypes.number.isRequired,
  tipoContrato: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  descricao: PropTypes.string,
  nome: PropTypes.string.isRequired,
  extencaoArquivo: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      downloadContratoDocumentoAuxiliar,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentoAuxiliarItem);
